import { render } from "./SearchMobile.vue?vue&type=template&id=3c3aa64c&scoped=true&ts=true"
import script from "./SearchMobile.vue?vue&type=script&lang=ts"
export * from "./SearchMobile.vue?vue&type=script&lang=ts"

import "./SearchMobile.vue?vue&type=style&index=0&id=3c3aa64c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3aa64c"]])

export default __exports__